import { getField, updateField } from 'vuex-map-fields';
import StorageService from '@/services/StorageService';
import CoursesService from '@/services/CoursesService';

const getDefaultState = function () {
    return {
        id: null,
        canDoTwoLecturesInOneDay: null,
        courseId: null,
        editorNote: null,
        fullName: null,
        imagePath: null,
        numberOfEveningPewWeek: null,
        numberOfLecturesPerDay: null,
        overallScore: null,
        lecturesCount: null,
        userId: null,
        regionIds: [],
        teacherSubjects: [],
        status: null
    };
};

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = getDefaultState();

const getters = {
    getField,
    form: (state) => ({
        id: state.id,
        canDoTwoLecturesInOneDay: state.canDoTwoLecturesInOneDay,
        courseId: state.courseId,
        editorNote: state.editorNote,
        fullName: state.fullName,
        imagePath: state.imagePath,
        numberOfEveningPewWeek: state.numberOfEveningPewWeek,
        numberOfLecturesPerDay: state.numberOfLecturesPerDay,
        overallScore: state.overallScore,
        lecturesCount: state.lecturesCount,
        userId: state.userId,
        regionIds: state.regionIds,
        teacherSubjects: state.teacherSubjects,
        status: state.status
    }),
};

const mutations = {
    setLecturesTeacher(state, value) {
        if (value) {
            // value.Transfers.forEach((status) => {
            //     status.Events.sort((a, b) => new Date(a.Date) - new Date(b.Date));
            // });
            Object.assign(state, value);
        } else {
            Object.assign(state, getDefaultState());
        }
    },

    storeReportDetails(state, data) {
        Object.assign(state, data);
    },
    updateField,
};

const actions = {
    async loadLecturesTeacher({ commit }, data) {
        const course = StorageService.getCourse();
        const res = await CoursesService.getCourseTeachers(course.id, {
            EntityId: data.id
        });
        commit('setLecturesTeacher', res.data.items[0]);
        return res.data;
    },
    async loadLecturesTeacherAdmin({ commit }, data) {
        const res = await CoursesService.getReportAdmin(data.id);
        commit('setLecturesTeacher', res.data);
        return res.data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
